export type { AccordionProps } from "@components/contracts/Accordion.types";
export { CelebrationAccordion } from "./Accordion.adapter";
